import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { CARDS_LIMIT } from 'core/modules/Instore2/utils/constants';

function CardsLimitWarning({ shouldShowWarning }) {
  if (!shouldShowWarning) return null;

  return (
    <div className="mn_cardsLimitWarning">
      As of 10/22/2025 you may only have up to {CARDS_LIMIT} cards saved to your account at one time.
      To add a new card, please remove existing card(s) first.
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><CardsLimitWarning {...props} /></ComponentErrorBoundary>;
